<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-22 23:53:33
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-27 16:47:05
 * @FilePath: /gamefi/components/Casino/GameSettings/Button/Fast.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <GameSettingsButtonWrapper
        tool-tip=""
        @click="onClick()"
    >
        <IconSvgUse
            size="14px"
            use="icon-settings-new"
        />
        <q-menu :offset="[0, 12]" 
            width="380px"
            :anchor="oMenuPotition.anchor" 
            :self="oMenuPotition.self" 
            :ref="el => oMenu = el"
        >
            <div class="pop-box">
                <!-- 
                    ↓ 这是手工平仓确认的开关 
                    ↓ 未登录时显示为禁用状态，防止用户点击 
                -->
                <div class="one-row">
                    <label class="row-label">
                        {{ $t('waves.ConfirmCashOut') }}
                    </label>
                    <Toggle
                        color="blue"
                        v-model="oWavesSetting.confirmCashOut"
                        :disabled="!oUserStore.isLoggedIn"
                    ></Toggle>
                </div>
                <div class="one-row">
                    <label class="row-label">
                        {{ $t('waves.ConfirmAllCashOut') }}
                    </label>
                    <Toggle
                        color="blue"
                        v-model="oWavesSetting.confirmAllCashOut"
                        :disabled="!oUserStore.isLoggedIn"
                    ></Toggle>
                </div>
                <div class="one-row">
                    <label class="row-label">
                        {{ $t('music.Music') }}
                    </label>
                    <Toggle
                        color="blue"
                        v-model="oSettingsStore.inhouseGames.sound.on"
                        :disabled="!oUserStore.isLoggedIn"
                    ></Toggle>
                </div>
                <!-- 
                    ↑ 常驻内容
                    ↓ 小屏幕时才显示的内容 ==========================
                -->
                <div v-if="oElementVisible.outerFairness == false" 
                    class="one-row"
                    @click="fairnessChecking"
                >
                    <label class="row-label">
                        {{
                            // ↓ 下方变量不使用 .value 有意外 
                            oChartState.isCorgiWaves.value
                            ? $t('waves.ProvablyFair')
                            : $t('waves.PriceFormulation')
                        }}
                    </label>
                    <q-icon name="open_in_new" class="my-auto text-[15px]" />
                </div>
                <!-- ↓ 图表时间粒度选择器 --> 
                <div class="one-row"
                    v-if="oElementVisible.outerTimePick == false" 
                >
                    <DurationPicker
                        class="row-label"
                        skin="label"
                    >
                    </DurationPicker>
                </div>
            </div>
        </q-menu>
    </GameSettingsButtonWrapper>
</template>

<script setup lang="ts">
import {useUserStore} from '@/stores/user';
import useTranslation from '~/i18n/useTransLation';
import DurationPicker from '@/pages/casino/futuresGame/_components/durationPicker.vue';
import useGlobalStore from '@/stores/global';
import useSettingsStore from '@/stores/settings/index'; 
import {
    settingsState_f, 
    fnSettingCenter_Ft, 
    oElementVisible,
    fnGetChartStateToolbox_oi, 
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 
import {jump2Formulation } from '@/pages/casino/futuresGame/ts/wavesFn'; 

const oSettingsStore = useSettingsStore(); 
const userSpecialCoin = false; 
const oWavesSetting = settingsState_f.userSettings; 
const oUserStore = useUserStore(); 
const oSettingCenter = fnSettingCenter_Ft();
const oChartState = fnGetChartStateToolbox_oi();
const t = useTranslation();
const props = defineProps({
    // modelValue: { // 目前没有用到 
    //     type: Boolean,
    //     default: false,
    // },
    showFairnessDialog: { 
        type: Function,
    },
});

const oMenu = ref(null);
const emit = defineEmits(['update:modelValue']);
const globalStore = useGlobalStore();

const oMenuPotition = (()=>{
    if (globalStore.innerWidth < 768){
        return {
            anchor: "bottom right", 
            self: "top right", 
        };
    }
    return {
        anchor: "bottom middle",
        self: "top middle",
    };
})();

const onClick = () => {
    // console.log("gear was clicked", );
};

// ↓ 打开窗口或跳到新页面 
function fairnessChecking(){
    if (oChartState.isCorgiWaves.value){
        oMenu.value.hide(); 
        props.showFairnessDialog();
        return;
    }
    console.log("跳转到新页面", ); 
    jump2Formulation();
};

watch(
    () => oWavesSetting, 
    async (oNew)=>{
        // ↓ 记录用户设定到后端，以供刷新后查询 
        console.log("用户配置已经修改 ↓\n", deepCopy(oNew)); 
        const {hasLogged} = await getUserInfo();
        if (!hasLogged) return; 
        // ↓ 不需要参数 
        oSettingCenter.setUserSettings(); 
    },
    { deep: true },
);

</script>


<style lang="scss" scoped>
.pop-box{
    background-color: var(--color_grey-100);
    border-color: var(--color_grey-100);
    color: #93ACD3;
    border-style: solid;
    box-shadow: 2px 2px 20px #0000004d;
    border-radius: 10px;
    border-width: 2px;
    font-size: 14px;
    padding: 2px;
    z-index: 1;
    padding: 12px;
}

.one-row{
    display: flex;
    justify-content: space-between;
    cursor: pointer !important;
    &:hover{
        .row-label{
            filter: brightness(1.2);
        }
        :deep(){
            .toggle-body:after{
                background-color: white; 
            }
        }
    }
    & + .one-row{
        margin-top: 8px; 
    }
    .row-label{
        cursor: pointer !important;
        font-weight: 600;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: -.02em;
        line-height: 20px;
        & + *{
            margin-left: 20px;
        }
    }
}

</style>

